import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";

// Appears once the first CTA button has scrolled out of view.
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const first = document.getElementById("first-cta");
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="19785q3q3qbdq">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-2 sm:bottom-4 sm:left-auto sm:right-4 sm:px-0" data-id="element-36" data-mp="197zscp1q0yrv">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-cta px-5 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(22,163,74,0.7)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-ctaDark sm:w-auto" data-id="element-37" data-mp="21c4ckkrffc04">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="1iejnpdonwdfi" />
            <span className="whitespace-nowrap" data-id="element-39" data-mp="1ncl41qupdyna">Get instant access — $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}